var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Chip, IconButton, Link, Tab, Typography, useMediaQuery, useTheme } from '@mui/material';
import { BubbleChatIcon, Delete02Icon, InformationCircleIcon } from 'hugeicons-react';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppConsts } from '../../../application/common/constants/app-consts';
import { useGetDislikedConversationsQuery, useUpdateTrainingStatusMutation } from '../../../application/features/chat/chat-api';
import useTranslate from '../../../localization/helpers';
import ConfirmDialog from '../../components/ConfirmDialog';
import ProtectedElement from '../../components/ProtectedElement';
import AiUserIcon from '../../icons/components/ai-user';
import { Permissions } from '../../permissions';
import FeedbackCards from './feedback-cards';
import FeedbackDataGrid from './feedback-datagrid';
import Insights from './personnel';
var Training = function () {
    var _a;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var navigate = useNavigate();
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isMd = useMediaQuery(theme.breakpoints.only('md'));
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var isIpadMiniLandscape = useMediaQuery('(max-width: 1024px) and (orientation: landscape)');
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var isIpadMini = useMediaQuery('(min-width:768px) and (max-width:1024px) ');
    var _b = __read(useState({ isOpen: false }), 2), deleteConfirm = _b[0], setDeleteConfirm = _b[1];
    var _c = __read(useState(new Set()), 2), expandedRows = _c[0], setExpandedRows = _c[1];
    var _d = __read(useState('Feedback'), 2), tabValue = _d[0], setTabValue = _d[1];
    var _e = __read(useState({
        page: AppConsts.DEFAULT_PAGE_NUMBER,
        pageSize: AppConsts.DEFAULT_PAGE_SIZE,
        sortField: AppConsts.DEFAULT_SORT_FIELD_MONGO,
        sortDirection: AppConsts.DEFAULT_SORT_DIRECTION,
        filterField: undefined,
        filterOperator: undefined,
        filterValue: undefined
    }), 2), conversationsQuery = _e[0], setConversationsQuery = _e[1];
    var _f = __read(useState({
        items: []
    }), 2), filterModel = _f[0], setFilterModel = _f[1];
    var _g = __read(useUpdateTrainingStatusMutation(), 2), deleteTraining = _g[0], _h = _g[1], deleteTrainingLoading = _h.isLoading, isSuccess = _h.isSuccess;
    var data = useGetDislikedConversationsQuery(conversationsQuery, {
        refetchOnMountOrArgChange: true
    }).data;
    var _j = data !== null && data !== void 0 ? data : {}, _k = _j.items, conversations = _k === void 0 ? [] : _k, totalCount = _j.totalCount;
    useEffect(function () {
        if (isSuccess)
            setDeleteConfirm({ isOpen: false });
    }, [isSuccess]);
    var rowCountRef = useRef((_a = data === null || data === void 0 ? void 0 : data.totalCount) !== null && _a !== void 0 ? _a : 0);
    var rowCount = useMemo(function () {
        if (totalCount !== undefined) {
            rowCountRef.current = totalCount;
        }
        return rowCountRef.current;
    }, [totalCount]);
    var handlePaginationModelChange = function (model) {
        setConversationsQuery(function (prev) { return (__assign(__assign({}, prev), { page: model.page + 1, pageSize: model.pageSize })); });
    };
    var handleSortModelChange = function (model) {
        setConversationsQuery(function (prev) {
            var _a, _b, _c, _d;
            return (__assign(__assign({}, prev), { sortField: (_b = (_a = model[0]) === null || _a === void 0 ? void 0 : _a.field) !== null && _b !== void 0 ? _b : AppConsts.DEFAULT_SORT_FIELD_MONGO, sortDirection: (_d = (_c = model[0]) === null || _c === void 0 ? void 0 : _c.sort) !== null && _d !== void 0 ? _d : AppConsts.DEFAULT_SORT_DIRECTION }));
        });
    };
    var handleFilterModelChange = function (model) {
        if (model.items.length > 0) {
            var filterItem_1 = model.items[0];
            if (filterItem_1.operator !== 'isEmpty' &&
                filterItem_1.operator !== 'isNotEmpty' &&
                (filterItem_1.value === '' ||
                    (Array.isArray(filterItem_1.value) && filterItem_1.value.length === 0) ||
                    filterItem_1.value === undefined)) {
                setConversationsQuery(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
            }
            else {
                setConversationsQuery(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), { filterField: filterItem_1.field, filterOperator: filterItem_1.operator, filterValue: (_a = filterItem_1.value) === null || _a === void 0 ? void 0 : _a.toString() }));
                });
            }
        }
        else {
            // When model.items is empty, clear all filters
            setConversationsQuery(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
        }
        setFilterModel(model);
    };
    var handleTabChange = function (_event, newValue) {
        setTabValue(newValue);
    };
    var handleToggleExpand = function (id) {
        setExpandedRows(function (prev) {
            var newExpandedRows = new Set(prev);
            if (newExpandedRows.has(id)) {
                newExpandedRows.delete(id);
            }
            else {
                newExpandedRows.add(id);
            }
            return newExpandedRows;
        });
    };
    var handleDeleteTraining = function (conversation) {
        deleteTraining({
            conversationId: conversation.conversationId,
            userId: conversation.userId
        });
    };
    var handleConversationDetail = function (conversation) {
        navigate("/training/chat-details/".concat(conversation.conversationId, "/").concat(conversation.userId), {
            state: {
                conversationName: conversation.conversationName
            }
        });
    };
    var cloumns = [
        {
            field: 'time',
            filterable: false,
            headerName: translate('common.date'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 2 : 2,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            type: 'string',
            renderCell: function (params) {
                return (_jsxs(Box, { children: [_jsx(Typography, { children: new Date(params.row.date).toLocaleDateString(translate('common.dateLanguageCode1'), {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric'
                            }) }), _jsx(Typography, { variant: 'caption', color: 'textSecondary', children: new Date(params.row.date).toLocaleTimeString(translate('common.dateLanguageCode2'), {
                                hour12: true,
                                hour: '2-digit',
                                minute: '2-digit'
                            }) })] }));
            }
        },
        {
            field: 'chatBy',
            headerName: translate('common.chatBy'),
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 2 : 2,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            type: 'string'
        },
        {
            field: 'machines',
            headerName: translate('common.assets'),
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 2 : 2,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            type: 'string',
            renderCell: function (params) {
                var machines = params.row.machines;
                var displayCount = 1;
                var isExpanded = expandedRows.has(params.row.conversationId);
                var machinesToShow = isExpanded ? machines : machines.slice(0, displayCount);
                var remainingCount = machines.length - displayCount;
                return (_jsxs(Box, { children: [machinesToShow.map(function (machine) { return (_jsx(Typography, { children: machine }, machine)); }), remainingCount > 0 && !isExpanded && (_jsxs(Link, { href: '#', underline: 'none', variant: 'body2', onClick: function (e) {
                                e.preventDefault();
                                handleToggleExpand(params.row.conversationId);
                            }, children: ["+", remainingCount, " ", translate('common.more')] })), isExpanded && (_jsx(Link, { href: '#', underline: 'none', variant: 'body2', onClick: function (e) {
                                e.preventDefault();
                                handleToggleExpand(params.row.conversationId);
                            }, children: translate('common.showLess') }))] }));
            }
        },
        {
            field: 'chatSource',
            headerName: translate('common.chatSource'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 2 : 2,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            type: 'string',
            renderCell: function (params) {
                if (!params.value) {
                    return null;
                }
                return translate("common.".concat(params.value.toLowerCase()));
            }
        },
        {
            field: 'status',
            filterable: false,
            headerName: translate('common.status'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1.5 : 1.5,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            type: 'string',
            renderCell: function (params) {
                var color;
                var translatedLabel = '';
                switch (params.row.status) {
                    case 'New':
                        translatedLabel = translate('training.new');
                        color = 'default';
                        break;
                    case 'Resolved':
                        translatedLabel = translate('training.resolved');
                        color = 'success';
                        break;
                    case 'Partially Resolved':
                        translatedLabel = translate('training.partiallyResolved');
                        color = 'warning';
                        break;
                    default:
                        color = 'default';
                        break;
                }
                return _jsx(Chip, { label: translatedLabel, color: color, variant: 'soft', size: 'medium' });
            }
        },
        {
            field: 'action',
            headerName: '',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            width: isXs ? 100 : isMd ? 100 : isscreen600900 ? 100 : undefined,
            renderCell: function (params) {
                return (_jsxs("div", { style: {
                        display: 'flex',
                        alignContent: 'center',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }, children: [_jsx("div", { children: _jsx(ProtectedElement, { permissions: [Permissions.Training.Delete], children: _jsx(IconButton, { disabled: deleteTrainingLoading, onClick: function (e) {
                                        e.stopPropagation();
                                        setDeleteConfirm({ isOpen: true, conversation: params.row });
                                    }, color: 'error', size: 'small', children: _jsx(Delete02Icon, { size: 20 }) }) }) }), _jsx("div", { children: _jsx(IconButton, { color: 'primary', size: 'small', onClick: function (e) {
                                    e.stopPropagation();
                                    handleConversationDetail(params.row);
                                }, children: _jsx(InformationCircleIcon, { size: 20 }) }) })] }));
            }
        }
    ];
    return (_jsxs(Box, { sx: {
            width: '100%',
            padding: isXs ? '16px' : '8px',
            display: 'flex',
            height: 'max-content',
            flexDirection: 'column',
            position: 'relative'
        }, children: [_jsx(Box, { padding: isXs ? undefined : isscreen600900Landscape ? 0 : isSm ? 1 : 1, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', children: _jsx(Typography, { variant: isXs ? 'h4' : 'h3', color: '#009983', children: translate('common.training') }) }), _jsx(Box, { sx: { width: '100%' }, children: _jsxs(TabContext, { value: tabValue, children: [_jsx(Box, { sx: {
                                display: 'flex',
                                justifyContent: 'flex-start',
                                marginLeft: 1
                            }, children: _jsxs(TabList, { onChange: handleTabChange, "aria-label": 'Training tabs', children: [_jsx(Tab, { iconPosition: 'start', label: 'Feedback', value: 'Feedback', icon: _jsx(BubbleChatIcon, {}), sx: {
                                            borderRadius: '16px',
                                            color: tabValue === 'Feedback' ? '#161C24 !important' : '#454F5B !important'
                                        } }), _jsx(Tab, { disabled: true, iconPosition: 'start', label: translate('training.insights'), value: 'Insights', icon: _jsx(AiUserIcon, {}), sx: {
                                            textAlign: 'center',
                                            borderRadius: '16px',
                                            color: tabValue === 'Insights' ? '#161C24 !important' : '#919EAB !important'
                                            // color: tabValue === 'Insights' ? '#161C24 !important' : '#454F5B !important'
                                        } })] }) }), _jsx(Box, { sx: { width: '100%' }, children: _jsx(TabPanel, { value: 'Feedback', sx: { padding: '6px' }, children: _jsx(Box, { children: isXs || isIpadMini || isIpadMiniLandscape ? (_jsx(FeedbackCards, { conversations: conversations, handleConversationDetails: handleConversationDetail, onDeleteConversation: function (conversation) {
                                            return setDeleteConfirm({ isOpen: true, conversation: conversation });
                                        }, conversationsQuery: conversationsQuery, setConversationsQuery: setConversationsQuery })) : (_jsx(FeedbackDataGrid, { rows: conversations, columns: cloumns, rowCount: rowCount, paginationModel: {
                                            page: conversationsQuery.page - 1,
                                            pageSize: conversationsQuery.pageSize
                                        }, filterModel: filterModel, onFilterModelChange: handleFilterModelChange, onPaginationModelChange: handlePaginationModelChange, onSortModelChange: handleSortModelChange, onRowClick: handleConversationDetail })) }) }) }), _jsx(Box, { sx: { width: '100%' }, children: _jsx(TabPanel, { value: 'Insights', sx: { padding: '6px' }, children: _jsx(Insights, {}) }) })] }) }), _jsx(ConfirmDialog, { disabled: deleteTrainingLoading, open: deleteConfirm.isOpen, onConfirm: function () { return handleDeleteTraining(deleteConfirm.conversation); }, onClose: function () { return setDeleteConfirm({ isOpen: false }); }, closeButtonText: translate('actions.cancel'), confirmButtonText: translate('actions.confirm'), content: translate('training.archiveConversationText'), title: translate('training.archiveConversation') })] }));
};
export default Training;
